// extracted by mini-css-extract-plugin
export default {"header":"Home_header__jgN9+","rate":"Home_rate__N8WEd"};